import * as Sentry from '@sentry/vue';

function parseJoiMessage(message: any) {
  const fields: any[] = [];
  if (message.response && message.response.data && message.response.data.errors) {
    for (const field of message.response.data.errors) {
      fields.push(field.messages[0]);
    }
    return fields.join('<br/>');
  } else if (message.response && message.response.data && message.response.data.message) {
    return message.response.data.message;
  } else if (message.message) {
    return message.message;
  } else if (message.msg) {
    return message.msg;
  }
  return message;
}

function sendSentryError(ex: Error | string) {
  if (ex instanceof Error) {
    Sentry.captureException(ex);
  } else {
    Sentry.captureException(new Error(ex));
  }
}

// @ts-ignore
export const stop = async ({ commit }) => {
  commit('stop');
};

// @ts-ignore
export const warning = async ({ commit }, message) => {
  commit('start', { message: parseJoiMessage(message), color: 'warning' });
};

// @ts-ignore
export const danger = async ({ commit }, message) => {
  commit('start', { message: parseJoiMessage(message), color: 'error' });
};

// @ts-ignore
export const error = async ({ commit }, message: Error | string) => {
  sendSentryError(message);
  commit('start', { message: parseJoiMessage(message), color: 'error' });
};

// @ts-ignore
export const notify = async ({ commit }, message) => {
  commit('start', { message: parseJoiMessage(message), color: 'orange darken-1' });
};

// @ts-ignore
export const info = async ({ commit }, message) => {
  commit('start', { message: parseJoiMessage(message), color: 'info' });
};

// @ts-ignore
export const success = async ({ commit }, message) => {
  commit('start', { message: parseJoiMessage(message), color: 'success' });
};
